import { jsonp } from '@ifeng-fe/ui_base';
import { formatHotListData } from '@ifeng-fe/container_content/common/client/utils/formatComment.js';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}

const md5 = require('@ifeng-fe/md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

let host = '';

if (typeof window !== 'undefined') {
    host = window.location.host;
}

export const getDayWeeklyRankComment = async doc_url => {
    try {
        return await jsonp('https://comment.ifeng.com/get/dayweekrank', {
            data: {
                doc_url,
                format: 'js',
            },
            jsonpCallback: 'getHotRank',
            cache: false,
        });
    } catch (e) {
        console.error(e);

        return { dayTop: [], weekTop: [] };
    }
};

/**
 * 点赞评论
 * @param {String} doc_url doc_url
 * @param {String} vote_user vote_user
 * @param {String} cmtid cmtid
 * @param {Number} number number
 */

export const voteCmt = async (doc_url, vote_user, cmtid, number = 1) => {
    return await jsonp('http://comment.ifeng.com/vote/up', {
        data: {
            doc_url,
            vote_user,
            cmtid,
            number,
            format: 'js',
        },
        jsonpCallback: 'voteCmt',
    });
};

// 提交评论
export const postComment = async (content, config) => {
    const data = await jsonp('http://comment.ifeng.com/post', {
        data: {
            doc_url: config.docUrl,
            docName: config.docTitle,
            content,
            skey: config.skey,
            from: 'pc',
            quote_id: config.quote_id,
            format: 'js',
            callback: 'postCmt',
        },
        jsonpCallback: 'postCmt',
        cache: false,
    });

    return data;
};

/**
 * 获取评论列表
 * @param {*} getUrl
 * @param {*} orderby
 * @param {*} docUrl
 * @param {*} sKey
 * @param {*} hotLimit
 */
export const getCommentList = async (getUrl, orderby, docUrl, sKey, page, pageSize) => {
    const data = await jsonp(getUrl, {
        data: {
            orderby,
            docUrl,
            format: 'js',
            job: 1,
            p: page,
            pageSize,
            callback: `${createJsonpCallbackName('newCommentListCallBack')}`,
            skey: sKey,
        },
        jsonpCallback: `${createJsonpCallbackName('newCommentListCallBack')}`,
        cache: true,
    });

    // 格式化评论数据
    data.comments = formatHotListData(data.comments);

    return data;
};

/**
 * 获取即发即显评论
 * @param {String} doc_url
 */
export const getTempCommentList = async doc_url => {
    const data = await jsonp('http://comment.ifeng.com/get/tempcomment', {
        data: {
            doc_url,
            format: 'js',
        },
        jsonpCallback: 'getTempComments',
        cache: false,
    });

    // 格式化评论数据
    return formatHotListData(data);
};

/**
 * 获取用户 guid
 * @param {String} sid sid
 */
export const getGuid = async sid => {
    const guid = await jsonp('//id.ifeng.com/api/getuid', {
        data: {
            sid,
        },
        cache: true,
    });

    return guid;
};
